export function setupVideoList(selector = '.video-list') {
   
    document.querySelector(".stop-button-current").addEventListener('click', () => {
        let holder = document.body.querySelector(".employee-list__list.active");
        
        holder.classList.remove('active');

        let videoPositionHolder = document.body.querySelector(".js-active")
        
        videoPositionHolder.classList.add("js-hidden")
        videoPositionHolder.classList.remove("js-active")

        player.playVideo();
    });

    const videoLists = document.body.querySelectorAll(selector);
    
    for (let i = 0; i < videoLists.length; i++) {
        
        let videos = videoLists[i].querySelectorAll('.video');
        
        for (let o = 0; o < videos.length; o++) {

            let playerId = videos[o].getAttribute("data-id")
            
            const videoPositionHolder = document.body.querySelector("#" + playerId);
            const videoPosition = videoPositionHolder.querySelector(".player-position");
            
            if(!videoPosition) {
                continue;
            }
            
            const videoId = videoPosition.getAttribute('data-video-id');

            let player;
            
            setTimeout(() => {
                player = new YT.Player(videoPosition.getAttribute('id'), {
                    videoId,
                    playerVars: {
                        'playsinline': 1
                    }
                });
            }, 1000);

            videos[o].querySelector('.play-button').addEventListener('click', () => {
                videos[o].parentElement.classList.add('active');

                videoPositionHolder.classList.remove("js-hidden")
                videoPositionHolder.classList.add("js-active")
                
                player.playVideo();
            });
            
        }
        
    }
}
